import { formatDate } from '@/utils/date_manipulation'
import { appendHelpers } from '../helpers/helpers_manager'

const moduleName = '.instagram'

export default ({
  repository,
  clientWrapper,
  context
}) => ({
  countByRange: (startDate, endDate) => {
    context.lastApiPath = `${moduleName}.countByRange`

    return clientWrapper.api.get('/resources/count.json', {
      params: {
        start_date: formatDate({ date: startDate }),
        end_date: formatDate({ date: endDate }),
        resource_types: 'social'
      }
    })
  },

  searchByDates: (startDate, endDate, filters) => {
    context.lastApiPath = `${moduleName}.searchByDates`
    const helpers = ['issue', 'status', 'revision', 'images', 'rects']
    const params = {
      start_date: formatDate({ date: startDate }),
      end_date: formatDate({ date: endDate }),
      page: filters.page,
      page_size: filters.page_size,
      resource_types: 'social',
      statuses: ['ready']
    }

    if (filters.show_archived == 1) params.statuses = [...params.statuses, 'completed']
    if (filters.show_discarded == 1) params.statuses = [...params.statuses, 'discarded']

    params.statuses = params.statuses.join(',')

    return clientWrapper.api
      .get('/resources/search_by_batch_dates.json', { params })
      .then(({ data }) => data.map(resource => resource.attributes))
      .then(resources => resources.map(resource => appendHelpers(resource, repository, helpers)))
  }
})